<script lang="ts">
import { defineComponent } from 'vue-demi'

export default defineComponent({
  props: {
    width: {type: Number, required: true},
    height: {type: Number, required: true},
  },
  data() {
    return {
    }
  },
  methods: {
  },
})
</script>

<template>
  <div
    role="presentation"
    :style="{width: `${width}px`, height: `${height}px`}"
  >
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8008 19.8576C23.8008 20.2476 23.7141 20.6484 23.53 21.0384C23.3458 21.4284 23.1075 21.7967 22.7933 22.1434C22.2625 22.7284 21.6775 23.1509 21.0166 23.4217C20.3666 23.6926 19.6625 23.8334 18.9041 23.8334C17.7991 23.8334 16.6183 23.5734 15.3725 23.0426C14.1266 22.5117 12.8808 21.7967 11.6458 20.8976C10.4 19.9876 9.21913 18.9801 8.09246 17.8642C6.97663 16.7376 5.96913 15.5567 5.06996 14.3217C4.18163 13.0867 3.46663 11.8517 2.94663 10.6276C2.42663 9.39258 2.16663 8.21175 2.16663 7.08508C2.16663 6.34841 2.29663 5.64425 2.55663 4.99425C2.81663 4.33341 3.22829 3.72675 3.80246 3.18508C4.49579 2.50258 5.25413 2.16675 6.05579 2.16675C6.35913 2.16675 6.66246 2.23175 6.93329 2.36175C7.21496 2.49175 7.46413 2.68675 7.65913 2.96841L10.1725 6.51091C10.3675 6.78175 10.5083 7.03091 10.6058 7.26925C10.7033 7.49675 10.7575 7.72425 10.7575 7.93008C10.7575 8.19008 10.6816 8.45008 10.53 8.69925C10.3891 8.94841 10.1833 9.20841 9.92329 9.46841L9.09996 10.3242C8.98079 10.4434 8.92663 10.5842 8.92663 10.7576C8.92663 10.8442 8.93746 10.9201 8.95913 11.0067C8.99163 11.0934 9.02413 11.1584 9.04579 11.2234C9.24079 11.5809 9.57663 12.0467 10.0533 12.6101C10.5408 13.1734 11.0608 13.7476 11.6241 14.3217C12.2091 14.8959 12.7725 15.4267 13.3466 15.9142C13.91 16.3909 14.3758 16.7159 14.7441 16.9109C14.7983 16.9326 14.8633 16.9651 14.9391 16.9976C15.0258 17.0301 15.1125 17.0409 15.21 17.0409C15.3941 17.0409 15.535 16.9759 15.6541 16.8567L16.4775 16.0442C16.7483 15.7734 17.0083 15.5676 17.2575 15.4376C17.5066 15.2859 17.7558 15.2101 18.0266 15.2101C18.2325 15.2101 18.4491 15.2534 18.6875 15.3509C18.9258 15.4484 19.175 15.5892 19.4458 15.7734L23.0316 18.3192C23.3133 18.5142 23.5083 18.7417 23.6275 19.0126C23.7358 19.2834 23.8008 19.5542 23.8008 19.8576Z"
        fill="white"
        stroke="white"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </svg>
  </div>
</template>

